import {createAction, props} from '@ngrx/store';
import {ApiShoppingCart} from '@api/shopping-carts';

export const loadShoppingCart = createAction('[ShoppingCart] load shopping cart', props<{
    id: string,
    token: string
}>());
export const loadShoppingCartSuccess = createAction('[ShoppingCart] load shopping cart success', props<{
    shoppingCart: ApiShoppingCart
}>());
export const loadShoppingCartFailure = createAction('[ShoppingCart] load shopping cart failure');

export const increaseRequestsCounter = createAction('[ShoppingCart] increase cart request counter');
export const increaseRequestsDone = createAction('[ShoppingCart] increase cart requests done');
export const setShoppingCartArticles = createAction('[ShoppingCart] set shopping cart articles', props<{
    jsonId: string,
    articles: { amount: number, articleNumber: string }[]
}>());
export const setShoppingCartArticlesSuccess = createAction('[ShoppingCart] set shopping cart articles success', props<{
    shoppingCart: ApiShoppingCart,
    notifications: { id: string, message: string }[]
}>());
export const setShoppingCartArticlesFailure = createAction('[ShoppingCart] set shopping cart articles failure');

export const setShoppingCartDynamicArticles = createAction('[ShoppingCart] set shopping cart dynamic articles', props<{
    jsonId: string,
    dynamicArticles: { amount: number, id: string }[]
}>());
export const setShoppingCartDynamicArticlesSuccess = createAction('[ShoppingCart] set shopping cart dynamic articles success', props<{
    shoppingCart: ApiShoppingCart,
    notifications: { id: string, message: string }[]
}>());
export const setShoppingCartDynamicArticlesFailure = createAction('[ShoppingCart] set shopping cart dynamic articles failure');

export const setShoppingCartVouchersSuccess = createAction('[ShoppingCart] set shopping cart vouchers success', props<{
    shoppingCart: ApiShoppingCart,
    notifications: { id: string, message: string }[]
}>());
export const updateShoppingCartSuccess = createAction('[ShoppingCart] update shopping cart success', props<{
    shoppingCart: ApiShoppingCart,
    notifications: { id: string, message: string }[]
}>());


export const refreshShoppingCartArticles = createAction('[ShoppingCart] refresh shopping cart', props<{
    jsonId: string,
    priceGroups?: string[],
    deliveryDate?: string
}>());
export const refreshShoppingCartSuccess = createAction('[ShoppingCart] refresh shopping cart success', props<{
    shoppingCart: ApiShoppingCart,
    notifications: { id: string, message: string }[]
}>());
export const refreshShoppingCartFailure = createAction('[ShoppingCart] refresh shopping cart failure');

export const deleteShoppingCart = createAction('[ShoppingCart] delete shopping cart', props<{
    id: string,
    token: string
}>());
export const deleteShoppingCartSuccess = createAction('[ShoppingCart] delete shopping cart success');
export const deleteShoppingCartFailure = createAction('[ShoppingCart] delete shopping cart failure');
